import * as React from 'react';
import SkipLink from '../SkipLink/SkipLink';
import S from './SectionWrapper.styles';
export var ContentType;
(function (ContentType) {
    ContentType["Default"] = "normal";
    ContentType["Engage"] = "engage";
})(ContentType || (ContentType = {}));
export var Theme;
(function (Theme) {
    Theme["Teal"] = "teal";
    Theme["Pear"] = "pear";
    Theme["Blue"] = "blue";
    Theme["DarkBlue"] = "dark-blue";
    Theme["ForrestGreen"] = "forrest-green";
    Theme["Purple"] = "purple";
    Theme["Yellow"] = "yellow";
    Theme["Orange"] = "orange";
    Theme["EngageGreen"] = "engage-green";
    Theme["EngageSeaGreen"] = "engage-sea-green";
    Theme["EngageTeal"] = "engage-teal";
    Theme["EngageLime"] = "engage-lime";
    Theme["EngageSky"] = "engage-sky";
    Theme["EngagePurple"] = "engage-purple";
    Theme["EngageLilac"] = "engage-lilac";
    Theme["EngageTangerine"] = "engage-tangerine";
    Theme["EngageLavender"] = "engage-lavender";
    Theme["EngagePink"] = "engage-pink";
    Theme["EngageYellow"] = "engage-yellow";
    Theme["EngageDusk"] = "engage-dusk";
    Theme["EngageCream"] = "engage-cream";
    Theme["White"] = "white";
    Theme["Black"] = "black";
    Theme["Bronze"] = "bronze";
    Theme["Silver"] = "silver";
    Theme["Gold"] = "gold";
    Theme["Outline"] = "outline";
})(Theme || (Theme = {}));
const SectionWrapper = React.forwardRef((props, ref) => {
    const { id, background, children, flush = 'none', layout = 'default', removeSkipLink, skipLinkType, translations, ...otherProps } = props;
    return (React.createElement(S.Container, { ref: ref, id: id, "data-background": background, "data-flush": flush, ...otherProps },
        !removeSkipLink ? (React.createElement(SkipLink, { type: skipLinkType, translations: translations })) : (React.createElement(S.FocusAnchor, { "aria-label": translations?.['global.skip.anchor'] })),
        renderLayout()));
    function renderLayout() {
        if (layout === 'fullWidth') {
            return children;
        }
        return React.createElement(S.Inner, null, children);
    }
});
SectionWrapper.displayName = 'SectionWrapper';
export default SectionWrapper;
